
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Cell from 'vux/src/components/cell/index.vue'

import { prizeHis, playerStatistics, addAddress } from '@/api/jingcai.js'
import addressPicker from '@/views/components/address-picker2'
import { getAddressDefault } from '@/api/user'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput,
Cell,
addressPicker
},
data () {
return {
baseUrl: config.baseUrl,
selected: 0,
tablist: [{
title: '开奖记录'
}, {
title: '参与记录'
}],
winList: [],
myjoinList: [],
showAddress: false,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: '',
cityid: '',
countyid: '',
provinceid: ''
},
partyid: this.$route.params.partyid,
addressValue: [],
addressid: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
mounted () {
this.myWin()
this.myjoin()
this.getAddress()
},
watch: {
addressValue: {
handler: function (val) {
this.personObj.provinceid = val[0]
this.personObj.cityid = val[1]
this.personObj.countyid = val[2]
},
deep: true
}
},
methods: {
ontab (index) {
this.selected = index
if (index === 0) {
}
},
myWin () {
prizeHis({
partyid: this.partyid
}).then(res => {
if (res.success) {
res.obj.forEach(item => {
var tel = ''
tel = '' + item.phone
var reg = /(\d{3})\d{4}(\d{4})/
item.phone = tel.replace(reg, '$1****$2')
})
this.winList = res.obj
}
})
},
myjoin () {
playerStatistics({
openid: this.accountid
}).then(res => {
if (res.success) {
this.myjoinList = res.obj
}
})
},

getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue !== '') {
this.personObj = res.returnValue
this.$set(this.addressValue, 0, res.returnValue.PROVINCEID.toString())
this.$set(this.addressValue, 1, res.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, res.returnValue.COUNTYID.toString())
this.personObj.ADDRESS = res.returnValue.ADDRESS
}
})
},
writeaddress (id) {
this.showAddress = true
this.addressid = id
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写收货地址！')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
addAddress({
id: this.addressid,
address: this.personObj.ADDRESS,
cityid: this.personObj.cityid,
countyid: this.personObj.countyid,
provinceid: this.personObj.provinceid
}).then(res => {
if (res.success) {
this.showAddress = false
this.$vux.toast.text('提交成功!')
}
})
}
}
}
